import VerticalTabs from "common/ComponentSidebar/ComponentSideBar";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import { useNavigate } from "react-router-dom";

interface tabProps {
    params: any;
    selectedIndex: number;
}
export default function PricelistTabs(props: tabProps) {
    const navigate = useNavigate();
    const handleChangeTabs = (tabId: number) => {
        if (tabId === 0) navigate(`/price-list/${props.params?.id}`);
        else if (tabId === 1) navigate(`/price-list/assign/package/${props.params?.id}`);
        else if (tabId === 2) navigate(`/price-list/assign/service/${props.params?.id}`);
        else if (tabId === 3) navigate(`/price-list/assign/part/${props.params?.id}`);
    }
    const tabs = [
        { id: 0, title: `edit`, child: <></> },
        { id: 1, title: `packages`, child: <></> },
        { id: 2, title: `services`, child: <></> },
        { id: 3, title: `items`, child: <></> }, 
    ];
    const disableTabs = tabs.map(tab => tab.id).filter(tabId => {
        switch (tabId) {
            case 0:
                return !checkPrivileges('ROLE_PRICELIST_UPDATE');
            case 1:
                return !checkPrivileges('ROLE_PACKAGE_PRICELIST_ASSIGN') && !checkPrivileges('ROLE_PACKAGE_PRICELIST_UNASSIGN');
            case 2:
                return !checkPrivileges('ROLE_SERVICE_PRICELIST_ASSIGN') && !checkPrivileges('ROLE_SERVICE_PRICELIST_UNASSIGN');
            case 3:
                return !checkPrivileges('ROLE_ITEM_PRICELIST_ASSIGN') && !checkPrivileges('ROLE_ITEM_PRICELIST_UNASSIGN');
            default:
              return false;
        }
    });
    return (<>
        <VerticalTabs tabs={tabs} selectedIndex={props.selectedIndex} handleChangeTabs={handleChangeTabs} disableTabNo={disableTabs} />
    </>);
}